import axios from 'axios';
import { firestore } from '../firebaseConfig';
import { collection, doc, getDocs, getDoc } from '@firebase/firestore';

export let BASE_URL = `https://${window.location.hostname}`;
let docketBaseUrl = '';
switch (window.location.hostname) {
  case 'app.survcart.com':
    BASE_URL = 'https://app.survcart.com';
    docketBaseUrl = 'https://app.yourdocket.com';
    break;
  case 'app.survcart.dev':
    BASE_URL = 'https://app.survcart.dev';
    docketBaseUrl = 'https://app.docket.works';
    break;
  case 'localhost':
    BASE_URL = 'http://localhost:5001/survcart-dev/us-central1';
    docketBaseUrl = 'http://localhost:5001/docket-dev-237ce/us-central1';

    if (window.docketConfig === 'prod') {
      BASE_URL = 'http://localhost:5001/survcart/us-central1';
      docketBaseUrl = 'http://localhost:5001/docket-3257f/us-central1';
    }
    break;
  default:
    BASE_URL = `https://${window.location.hostname}`;
    break;
}

let instance = axios.create({
  baseURL: `${BASE_URL}`,
  headers: {
    post: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  },
});

export const docketApi = axios.create({
  baseURL: docketBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const fetchCartConfigurations = async companyId => {
  try {
    const cartConfigs = await getDocs(
      collection(firestore, `companies/${companyId}/portalConfigs`),
    );
    const cartConfigsArray = [];
    cartConfigs.forEach(doc => {
      cartConfigsArray.push({ id: doc.id, ...doc.data() });
    });
    return cartConfigsArray;
  } catch (e) {
    throw e;
  }
};

export const resubmitOrder = async (apiKey, params) => {
  return axios.post(
    `${BASE_URL}/api/v1/webhooks/submit_order?api_key=${apiKey}`,
    params,
  );
};

export const API = instance;

export const DOCKET_API_URLS = {
  HTTP_API_READ: 'httpApiRead',
  HTTP_API_UPDATE: 'httpApiUpdate',
};

export const DOCKET_REQUEST_EVENT_TYPES = {
  MAX_DAILY_BOOKABLE_TASKS: 'max_daily_bookable_tasks',
};
